export const PRODUCT_LIST_VIDEO = "PRODUCT_LIST_VIDEO";
export const PRODUCT_SHOW_VIDEO = "PRODUCT_SHOW_VIDEO";
